import home from './home'
import board from './board'
import mypage from './mypage'
import webpart from './webpart'
import kyobobook from './kyobobook'

export default{
    home,
    board,
    mypage,
    webpart,
    kyobobook
}